import React from "react";
import { InvitedExpert, Participant } from "../../core/api/model";
import { DashboardExpertsList, DashboardExpertsListAdd } from "../DashboardExpertsList";
import { DashboardPanel, DashboardPanelItem } from "../DashboardPanel";
import { FormattedMessage, useIntl } from "react-intl";
import { Box, Button } from "@material-ui/core";
import CustomIcon from "../../core/custom-icon";

export interface DashboardExpertsPanelProps {
  experts: Participant[];
  invitedExperts: InvitedExpert[];
  deleteExpert: (expert: Participant) => void;
  addExpert: (email: string) => void;
}

export const DashboardExpertsPanel = (props: DashboardExpertsPanelProps) => {
  const [addOpen, setAddOpen] = React.useState<boolean>(false);

  const onAddCancel = () => {
    setAddOpen(false);
  }

  const onAddConfirm = (email: string) => {
    props.addExpert(email);
    setAddOpen(false);
  }
  const intl = useIntl();

  return (
    <DashboardPanel
      title={intl.formatMessage({id: 'DashboardExpertsTitle'})}
      addPanel={
        <Box width={{xs: '100%', md: 5/6}}
             mr={{xs: 1.5, md: 2}}
             position='relative'
        >
          {addOpen ? (
            <DashboardExpertsListAdd
              confirm={onAddConfirm}
              cancel={onAddCancel}
            />
          ) : (
            <Box position='absolute'
                 top={0}
                 right={0}
            >
              <Button color='secondary'
                      onClick={() => setAddOpen(true)}
                      endIcon={
                        <CustomIcon iconname='add' />
                      }
              >
                <FormattedMessage id='DashboardExpertsAdd' />
              </Button>
            </Box>
          )}
        </Box>
      }
    >
      <DashboardPanelItem tabtitle=''>
        <DashboardExpertsList
          experts={props.experts.slice().sort((a, b) => ( `${a.partName} ${a.partSurname}` < `${b.partName} ${b.partSurname}` ? -1 : 1 ))}
          invitedExperts={props.invitedExperts.slice().sort((a, b) => ( a.email < b.email ? -1 : 1 ))}
          deleteExpert={props.deleteExpert}
        />
      </DashboardPanelItem>
    </DashboardPanel>
  )
};
